




















import ProvinceForm from '@/components/province/ProvinceForm.vue';
import ProvinceUtils, { Province } from '@/utils/ProvinceUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { ProvinceForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<Province>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = ProvinceUtils.province.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();

          this.item = ProvinceUtils.province.generateDefault(
            await ProvinceUtils.province.api.create(this.item)
          );

          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [this.$tc('province.label')]),
            type: 'success',
          });
          this.$router.replace({ name: 'province-list' });
        } catch (error) {
          this.$toast.push({
            text: this.$t('error.create', [this.$tc('province.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
